import styled from 'styled-components'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const TwoFactorAuthSubtitle = styled.div`
  text-align: center;
  margin-bottom: 1em;
`;

export const ContentContainer = styled.div`
  width: 400px;
  margin: 0 auto;
`;

export const BackButton = styled(FontAwesomeIcon)`
  margin-right: 10px;
  cursor: pointer;
`;

export const ResendCodeContainer = styled.div`
  margin-top: 5px;
  color: rgb(0, 0, 238);
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
`;
